var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 12.4442,
    height: 12.4441,
    viewBox: "0 0 12.4442 12.4441",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M11.0238 0.24357C11.3486 -0.0811899 11.8758 -0.0811899 12.2006 0.24357C12.525 0.568255 12.525 1.09467 12.2006 1.41935L7.39787 6.22111L12.2006 11.0238C12.5254 11.3486 12.5254 11.8758 12.2006 12.2006C11.8758 12.5252 11.3485 12.5253 11.0238 12.2006L6.22111 7.39787L1.41935 12.2006C1.09466 12.5249 0.568241 12.525 0.24357 12.2006C-0.0811898 11.8758 -0.0811901 11.3486 0.24357 11.0238L5.04533 6.22111L0.24357 1.41935C-0.0809737 1.09463 -0.080975 0.568288 0.24357 0.24357C0.56833 -0.0811899 1.09557 -0.0811899 1.42033 0.24357L6.22209 5.04533L11.0238 0.24357Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerClose);
export default __webpack_public_path__ + "static/media/banner-close.f8678798980c4bbf4fb75fce7afd5e6d.svg";
export { ForwardRef as ReactComponent };